import React from 'react'
import Team from 'components/Team'
import { JerseyPlaceholder } from 'components/Jersey'
import Grid from '@material-ui/core/Grid'
import times from 'lodash-es/times'
import config from 'config'

const { TEAM_SIZE } = config

type TeamProps = React.ComponentProps<typeof Team>

type TeamWithPlaceholdersProps = TeamProps & {
  size?: number
}

const TeamWithPlaceholders: React.SFC<TeamWithPlaceholdersProps> = ({
  players, size = TEAM_SIZE, onPlayerSelected, ...props
}) => {
  const numNeededPlaceholders = size - players.length

  return (
    <Grid container alignItems="center" justify="space-around" {...props}>
      <Grid item style={{ flex: players.length }}>
        <Team
          showRemoveIcon
          players={players}
          justify="space-around"
          onPlayerSelected={onPlayerSelected}
        />
      </Grid>
      <Grid item style={{ flex: numNeededPlaceholders }}>
        <Grid container justify="space-around">
          {times(numNeededPlaceholders, (i) => (
            <Grid item key={i}>
              <JerseyPlaceholder />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TeamWithPlaceholders
